import React from 'react'
import { FormControl, Autocomplete, Box, TextField } from '@mui/material'
import { type PositionType } from 'services'
import { usePositionLuts } from 'components'

interface PositionTypeSelectorProps {
  handlePositionTypeChange: (country: PositionType[]) => void
  selectedTypes: PositionType[]
}
export const PositionTypeSelector: React.FC<PositionTypeSelectorProps> = ({ handlePositionTypeChange, selectedTypes }) => {
  const { lutValues: positionLutValues } = usePositionLuts()

  const handleTypePositionSelection = (event: React.ChangeEvent<any>, value: PositionType[]): void => {
    handlePositionTypeChange(value)
  }

  return (
    <FormControl fullWidth={true} variant="outlined">
      <Autocomplete
        id="position-type-select-multiple"
        value={selectedTypes}
        options={positionLutValues.positionTypes}
        multiple={true}
        getOptionLabel={(option) => option.typeDescShort}
        renderOption={(props, option) => (
          <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props} key={option.id}>
            {option.typeDescShort}
          </Box>
        )}
        onChange={handleTypePositionSelection}
        autoHighlight
        renderInput={(params) => (
          <TextField
            {...params}
            key={params.id}
            label="Choose Position Types"
            inputProps={{
              ...params.inputProps,
              autoComplete: 'new-password'
            }}
          />
        )}
      />
    </FormControl>
  )
}

export default PositionTypeSelector
